import { cssFunctions } from './cssFunctions';
import { Plugins } from './plugins';
export var defaultOptions = {
    isRTL: false,
    isMobile: false,
    strictMode: true,
};
export var plugins = new Plugins();
Object.keys(cssFunctions).forEach(function (funcName) { return plugins.addCssFunction(funcName, cssFunctions[funcName]); });
//# sourceMappingURL=common.js.map